<template>
  <div class="sidebar" v-if="showSidebar()">
    <div class="nav" id="content-items" v-if="visible">
      <ul class="list-group">
        <li
          v-for="item in list[index]" :key="item.id"
          class="list-group-item"
        >
            <a
              class="nav-item"
              :data-title="item.texto"
              @click="change_menu(item.indexList),change_page(item.route, item.id)"
            >
              <img
                class="nav-image"
                :id="item.id"
                :src="get_image(item.image)"
                @mouseover="change_image(item.id,item.image_h)"
                @mouseleave="change_image(item.id,item.image)"
              />
            </a>
        </li>
      </ul>
    </div>
    <div
      class="arrow-icon"
      data-title="Menú"
      @click="show_menu()"
    >
      <img :src="require('../SidebarMenu/arrow.png')" id="icon">
    </div>
  </div>
</template>

<script>
import menuOptions from '../SidebarMenu/SidebarMenuOptions'
import apiRoutes from '../../assets/js/api_routes'
import { mapMutations } from 'vuex'

export default {
  name: 'SidebarMenuIndex',

  data () {
    return {
      index: 0,
      visible: true
    }
  },

  props: {
    list: {
      default: menuOptions,
      type: Object
    }
  },

  methods: {
    ...mapMutations(['clear_options']),

    showSidebar() {
      return (this.$store.getters.isLoggedIn);
    },

    change_image (id, src) {
      document.getElementById(id).src = (require(`../../assets/images/sidebar/${src}`))
    },

    get_image (src) {
      return (require(`../../assets/images/sidebar/${src}`))
    },

    async change_page (route, id) {
      this.clear_options()
      if (id === '3') {
        window.location = apiRoutes.urlCdiac
      }if(id === '4'){
        this.$store.dispatch("logout")
        this.$router.push("/login")
      }else {
        this.$router.push(route)
      }
    },

    change_menu (indexList) {
      if (indexList != null) {
        this.index = indexList
      }
    },

    show_menu () {
      this.visible = !this.visible
      const arrow = document.getElementById('icon')
      if (this.visible) {
        arrow.style.transform = 'scaleX(-1)'
      } else {
        arrow.style.transform = 'scaleX(1)'
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
  left: 0;
  padding-top: 5rem;
  position:absolute;
  top: 0;
  z-index: 4;
}
.sidebar  li:hover {
  background-color: rgba(55, 55, 55, 0.6);
}

.nav {
  background-color: rgba(55, 55, 55, 0.8);
  border-bottom-right-radius: .5em;
  border-top-right-radius: .5em;
  box-shadow: .2em .2em 1em gray;
  display: flex;
  list-style: none;
}

.list-group,
.list-group-item,
.nav-item,
.nav-image {
  width: 100%;
}

.nav-image {
  height: 3rem;
}

.arrow-icon {
  align-items: center;
  background-color: rgba(168, 200, 79, 0.9);
  border-bottom-right-radius: .3em;
  border-top-right-radius: .3em;
  box-shadow: .1em .1em .8em gray;
  cursor: pointer;
  display: flex;
  height: 5rem;
  position: relative;
  width: 1.5rem;
}

.arrow-icon:hover {
  background-color: rgba(150, 172, 59, 0.9);
}

.list-group-item {
  background-color: transparent;
}

.nav-item[data-title]:hover:after {
  background:#343a40;
  border-radius: .5rem;
  color:#fff;
  content:attr(data-title);
  display: inline-block;
  left:100%;
  overflow: hidden;
  padding:5px 15px;
  position:absolute;
  top:20%;
  white-space:nowrap;
  z-index: 10;
  font-family: "Ancizar-regular", Helvetica, Arial;
}

.nav-image {
  width: 100%;
}

#icon {
  width: 100%;
  transform: scaleX(-1);
}
</style>